export interface CanvasLayout {
  readonly canvasWidth: number;
  readonly canvasHeight: number;
  readonly padding: number;
  readonly boardPixelWidth: number;
  readonly boardPixelHeight: number;
  readonly cellSize: number;
  readonly offsetX: number;
  readonly offsetY: number;
  readonly boardMaxX: number;
  readonly boardMaxY: number;
}

export function computeLayout(
  canvasWidth: number,
  canvasHeight: number,
  boardCols: number,
  boardRows: number,
  padding: number = 40,
): CanvasLayout {
  const availableWidth = canvasWidth - padding * 2;
  const availableHeight = canvasHeight - padding * 2;

  const cellSizeX = availableWidth / (boardCols - 1);
  const cellSizeY = availableHeight / (boardRows - 1);
  const cellSize = Math.min(cellSizeX, cellSizeY);

  const boardPixelWidth = cellSize * (boardCols - 1);
  const boardPixelHeight = cellSize * (boardRows - 1);

  const offsetX = (canvasWidth - boardPixelWidth) / 2;
  const offsetY = (canvasHeight - boardPixelHeight) / 2;

  return {
    canvasWidth,
    canvasHeight,
    padding,
    boardPixelWidth,
    boardPixelHeight,
    cellSize,
    offsetX,
    offsetY,
    boardMaxX: boardCols - 1,
    boardMaxY: boardRows - 1,
  };
}

export function boardToCanvas(
  boardX: number,
  boardY: number,
  layout: CanvasLayout,
): { x: number; y: number } {
  return {
    x: layout.offsetX + boardX * layout.cellSize,
    y: layout.offsetY + (layout.boardMaxY - boardY) * layout.cellSize,
  };
}

export function canvasToBoard(
  canvasX: number,
  canvasY: number,
  layout: CanvasLayout,
): { x: number; y: number } {
  return {
    x: (canvasX - layout.offsetX) / layout.cellSize,
    y: layout.boardMaxY - (canvasY - layout.offsetY) / layout.cellSize,
  };
}
